"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Badge = ({ children, className }) => {
    return ((0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)('_ml-1 _text-1 _text-uppercase _text-blue _font-weight-bold', className), children: children }));
};
exports.default = Badge;
